import { render, staticRenderFns } from "./FreightAndQuoteTable.vue?vue&type=template&id=00558b65&scoped=true"
import script from "./FreightAndQuoteTable.vue?vue&type=script&lang=js"
export * from "./FreightAndQuoteTable.vue?vue&type=script&lang=js"
import style0 from "./FreightAndQuoteTable.vue?vue&type=style&index=0&id=00558b65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00558b65",
  null
  
)

export default component.exports